"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useLocale, useTranslations } from "next-intl";
import { Link } from "@/navigation";
import { EEA_LOCALES, isEeaBuyer } from "@/lib/withdrawal";

// «Fortryd aftale» (forbrugeraftaleloven § 20 a; approval 390, EU/EEA only).
// EEA-market locales render it on the server. English and Faroese pages show
// it after hydration when the proxy's gg-country cookie (Vercel's IP country)
// is in the EEA, so a US visitor on /en never sees it (failure modes 14, 15).

function readCountryCookie(): string {
  const match = document.cookie.match(/(?:^|;\s*)gg-country=([A-Za-z]{2})/);
  return match?.[1]?.toUpperCase() ?? "";
}
export default function WithdrawalLink(t0) {
  const $ = _c(10);
  const {
    className
  } = t0;
  const locale = useLocale();
  const t = useTranslations("Withdrawal");
  let t1;
  if ($[0] !== locale) {
    t1 = EEA_LOCALES.has(locale);
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isEeaLocale = t1;
  const [isEeaCountry, setIsEeaCountry] = useState(false);
  let t2;
  let t3;
  if ($[2] !== isEeaLocale) {
    t2 = () => {
      if (isEeaLocale) {
        return;
      }
      setIsEeaCountry(isEeaBuyer({
        locales: [],
        country: readCountryCookie()
      }));
    };
    t3 = [isEeaLocale];
    $[2] = isEeaLocale;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  if (!isEeaLocale && !isEeaCountry) {
    return null;
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("footerLink");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== className || $[8] !== t4) {
    t5 = <Link className={className} href="/fortryd-aftale">{t4}</Link>;
    $[7] = className;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}